import { ContributorSteps, OnboardingSteps, PotluckSteps, ProfileSteps } from "components/workflow/utils";
import { StepComponentProps, StepComponentRef } from "utils/helpers";
import { Enums } from "utils";

export const stepRegistry: Record<string, {
  Component: React.ForwardRefExoticComponent<StepComponentProps<any> & React.RefAttributes<StepComponentRef<any>>>;
  skippable?: boolean;
}[]> = {
  [Enums.EnumFlow.Onboarding]: OnboardingSteps,
  [Enums.EnumFlow.Potluck]: PotluckSteps,
  [Enums.EnumFlow.Profile]: ProfileSteps,
  [Enums.EnumFlow.Contributor]: ContributorSteps,
};